export default "__VITE_ASSET__DLPdypV4__"